import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Users, Mail, Plus, MoreVertical, Search as SearchIcon, Check, X } from 'lucide-react';
import { AppShell } from '../components/AppShell';
function CreateGroupModal({
  onClose
}: {
  onClose: () => void;
}) {
  const [name, setName] = useState('');
  const [selectedMembers, setSelectedMembers] = useState<string[]>([]);
  const members = [{
    id: '1',
    name: 'Dr. Rossi',
    email: 'rossi@pharmacorp.com',
    initials: 'DR'
  }, {
    id: '2',
    name: 'María Gómez',
    email: 'mgomez@pharmacorp.com',
    initials: 'MG'
  }, {
    id: '3',
    name: 'J. Pérez',
    email: 'jperez@pharmacorp.com',
    initials: 'JP'
  }, {
    id: '4',
    name: 'L. Fernández',
    email: 'lfernandez@pharmacorp.com',
    initials: 'LF'
  }, {
    id: '5',
    name: 'A. López',
    email: 'alopez@pharmacorp.com',
    initials: 'AL'
  }];
  return <div className="fixed inset-0 z-50 flex items-center justify-center p-4" data-id="element-1084">
      <motion.div className="absolute inset-0 bg-navy-950/40 backdrop-blur-sm" onClick={onClose} initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} exit={{
      opacity: 0
    }} data-id="element-1085" />
      <motion.div className="relative bg-white rounded-xl shadow-dropdown border border-slate-200 w-full max-w-md overflow-hidden" initial={{
      opacity: 0,
      scale: 0.95,
      y: 10
    }} animate={{
      opacity: 1,
      scale: 1,
      y: 0
    }} exit={{
      opacity: 0,
      scale: 0.95,
      y: 10
    }} data-id="element-1086">
        <div className="flex items-center justify-between p-5 border-b border-slate-200" data-id="element-1087">
          <h2 className="text-lg text-navy-950" data-id="element-1088">Crear Nuevo Grupo</h2>
          <button onClick={onClose} className="text-slate-400 hover:text-navy-950 transition-colors p-1" data-id="element-1089">
            <X size={18} data-id="element-1090" />
          </button>
        </div>

        <div className="p-5 space-y-5" data-id="element-1091">
          <div className="space-y-1.5" data-id="element-1092">
            <label className="block text-sm font-medium text-navy-950" data-id="element-1093">
              Nombre del grupo
            </label>
            <input type="text" value={name} onChange={e => setName(e.target.value)} placeholder="Ej. Asuntos Regulatorios" className="w-full h-10 px-3 rounded-md border border-slate-200 text-sm outline-none focus:border-brand-500 focus:ring-1 focus:ring-brand-500" autoFocus data-id="element-1094" />
          </div>

          <div className="space-y-3" data-id="element-1095">
            <label className="block text-sm font-medium text-navy-950" data-id="element-1096">
              Miembros
            </label>
            <div className="max-h-56 overflow-y-auto space-y-1 pr-1" data-id="element-1097">
              {members.map(member => <button key={member.id} onClick={() => setSelectedMembers(prev => prev.includes(member.id) ? prev.filter(id => id !== member.id) : [...prev, member.id])} className="w-full flex items-center justify-between p-2 rounded-lg hover:bg-slate-50 transition-colors" data-id="element-1098">
                  <div className="flex items-center gap-3" data-id="element-1099">
                    <div className="w-8 h-8 rounded-full bg-slate-100 text-navy-600 flex items-center justify-center text-xs font-semibold border border-slate-200" data-id="element-1100">
                      {member.initials}
                    </div>
                    <div className="text-left" data-id="element-1101">
                      <p className="text-sm font-medium text-navy-950" data-id="element-1102">
                        {member.name}
                      </p>
                      <p className="text-xs text-navy-600" data-id="element-1103">{member.email}</p>
                    </div>
                  </div>
                  <div className={`w-4 h-4 rounded border flex items-center justify-center ${selectedMembers.includes(member.id) ? 'bg-brand-500 border-brand-500' : 'border-slate-300'}`} data-id="element-1104">
                    {selectedMembers.includes(member.id) && <Check size={12} className="text-white" data-id="element-1105" />}
                  </div>
                </button>)}
            </div>
          </div>
        </div>

        <div className="p-4 bg-slate-50 border-t border-slate-200 flex items-center justify-end gap-3" data-id="element-1106">
          <button onClick={onClose} className="text-sm font-medium text-navy-600 hover:text-navy-950 px-4 py-2 rounded-md hover:bg-slate-200 transition-colors" data-id="element-1107">
            Cancelar
          </button>
          <button disabled={!name.trim()} onClick={onClose} className="bg-brand-500 hover:bg-brand-400 disabled:bg-slate-200 disabled:text-slate-400 text-white text-sm font-medium px-5 py-2 rounded-md transition-colors shadow-sm" data-id="element-1108">
            Crear Grupo
          </button>
        </div>
      </motion.div>
    </div>;
}
export function TeamPage() {
  const [activeTab, setActiveTab] = useState<'miembros' | 'grupos'>('miembros');
  const [showCreateGroup, setShowCreateGroup] = useState(false);
  return <AppShell data-id="element-1109">
      <div className="p-6 lg:p-8 max-w-5xl mx-auto space-y-6" data-id="element-1110">
        <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4" data-id="element-1111">
          <div data-id="element-1112">
            <h1 className="text-2xl text-navy-950 mb-1" data-id="element-1113">Equipo</h1>
            <p className="text-sm text-navy-600" data-id="element-1114">
              Gestione los colaboradores de su espacio de trabajo y organícelos
              en grupos.
            </p>
          </div>
          <div className="flex items-center gap-3" data-id="element-1115">
            {activeTab === 'grupos' && <button onClick={() => setShowCreateGroup(true)} className="flex items-center justify-center gap-2 bg-white border border-slate-200 hover:border-brand-300 hover:bg-slate-50 text-navy-950 text-sm font-medium px-4 py-2.5 rounded-md transition-colors shadow-sm whitespace-nowrap" data-id="element-1116">
                <Users size={16} data-id="element-1117" />
                Crear Grupo
              </button>}
            <button className="flex items-center justify-center gap-2 bg-brand-500 hover:bg-brand-400 text-white text-sm font-medium px-5 py-2.5 rounded-md transition-colors shadow-sm whitespace-nowrap" data-id="element-1118">
              <Plus size={16} data-id="element-1119" />
              Invitar Colaborador
            </button>
          </div>
        </div>

        {/* Tabs */}
        <div className="flex items-center gap-6 border-b border-slate-200" data-id="element-1120">
          <button onClick={() => setActiveTab('miembros')} className={`pb-3 text-sm font-medium transition-colors relative ${activeTab === 'miembros' ? 'text-brand-600' : 'text-slate-400 hover:text-navy-950'}`} data-id="element-1121">
            Miembros (5)
            {activeTab === 'miembros' && <div className="absolute bottom-0 left-0 w-full h-0.5 bg-brand-500 rounded-t-full" data-id="element-1122" />}
          </button>
          <button onClick={() => setActiveTab('grupos')} className={`pb-3 text-sm font-medium transition-colors relative ${activeTab === 'grupos' ? 'text-brand-600' : 'text-slate-400 hover:text-navy-950'}`} data-id="element-1123">
            Grupos (3)
            {activeTab === 'grupos' && <div className="absolute bottom-0 left-0 w-full h-0.5 bg-brand-500 rounded-t-full" data-id="element-1124" />}
          </button>
        </div>

        {activeTab === 'miembros' ? <div className="bg-white rounded-xl border border-slate-200 shadow-card overflow-hidden" data-id="element-1125">
            <div className="p-4 border-b border-slate-200 bg-slate-50/50 flex items-center gap-4" data-id="element-1126">
              <div className="relative flex-1 max-w-md" data-id="element-1127">
                <SearchIcon className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-400" size={16} data-id="element-1128" />
                <input type="text" placeholder="Buscar por nombre o email..." className="w-full h-9 pl-9 pr-4 rounded-md border border-slate-200 text-sm outline-none focus:border-brand-500 focus:ring-1 focus:ring-brand-500" data-id="element-1129" />
              </div>
            </div>

            <div className="divide-y divide-slate-100" data-id="element-1130">
              {/* Admin User */}
              <div className="p-4 flex flex-col sm:flex-row sm:items-center justify-between gap-4 hover:bg-slate-50 transition-colors" data-id="element-1131">
                <div className="flex items-center gap-3" data-id="element-1132">
                  <div className="w-10 h-10 rounded-full bg-brand-500/20 text-brand-600 flex items-center justify-center text-sm font-semibold border border-brand-500/30" data-id="element-1133">
                    DR
                  </div>
                  <div data-id="element-1134">
                    <p className="text-sm font-medium text-navy-950" data-id="element-1135">
                      Dr. Rossi
                    </p>
                    <p className="text-xs text-navy-600" data-id="element-1136">
                      rossi@pharmacorp.com
                    </p>
                  </div>
                </div>
                <div className="flex items-center gap-4" data-id="element-1137">
                  <div className="hidden md:flex items-center gap-1.5" data-id="element-1138">
                    <span className="px-2 py-0.5 rounded-md bg-slate-100 text-navy-600 text-[10px] font-medium border border-slate-200" data-id="element-1139">
                      Asuntos Regulatorios
                    </span>
                    <span className="px-2 py-0.5 rounded-md bg-slate-100 text-navy-600 text-[10px] font-medium border border-slate-200" data-id="element-1140">
                      Dirección Técnica
                    </span>
                  </div>
                  <select className="text-xs font-medium text-navy-950 bg-transparent border-none outline-none cursor-pointer" data-id="element-1141">
                    <option data-id="element-1142">Admin</option>
                    <option data-id="element-1143">Editor</option>
                    <option data-id="element-1144">Viewer</option>
                  </select>
                  <button className="text-slate-400 hover:text-navy-950 p-1" data-id="element-1145">
                    <MoreVertical size={16} data-id="element-1146" />
                  </button>
                </div>
              </div>

              {/* Regular User 1 */}
              <div className="p-4 flex flex-col sm:flex-row sm:items-center justify-between gap-4 hover:bg-slate-50 transition-colors" data-id="element-1147">
                <div className="flex items-center gap-3" data-id="element-1148">
                  <div className="w-10 h-10 rounded-full bg-slate-100 text-navy-600 flex items-center justify-center text-sm font-semibold border border-slate-200" data-id="element-1149">
                    MG
                  </div>
                  <div data-id="element-1150">
                    <p className="text-sm font-medium text-navy-950" data-id="element-1151">
                      María Gómez
                    </p>
                    <p className="text-xs text-navy-600" data-id="element-1152">
                      mgomez@pharmacorp.com
                    </p>
                  </div>
                </div>
                <div className="flex items-center gap-4" data-id="element-1153">
                  <div className="hidden md:flex items-center gap-1.5" data-id="element-1154">
                    <span className="px-2 py-0.5 rounded-md bg-slate-100 text-navy-600 text-[10px] font-medium border border-slate-200" data-id="element-1155">
                      Asuntos Regulatorios
                    </span>
                    <span className="px-2 py-0.5 rounded-md bg-slate-100 text-navy-600 text-[10px] font-medium border border-slate-200" data-id="element-1156">
                      Comercio Exterior
                    </span>
                  </div>
                  <select className="text-xs font-medium text-navy-950 bg-transparent border-none outline-none cursor-pointer" data-id="element-1157">
                    <option data-id="element-1158">Editor</option>
                    <option data-id="element-1159">Viewer</option>
                    <option data-id="element-1160">Admin</option>
                  </select>
                  <button className="text-slate-400 hover:text-navy-950 p-1" data-id="element-1161">
                    <MoreVertical size={16} data-id="element-1162" />
                  </button>
                </div>
              </div>

              {/* Regular User 2 */}
              <div className="p-4 flex flex-col sm:flex-row sm:items-center justify-between gap-4 hover:bg-slate-50 transition-colors" data-id="element-1163">
                <div className="flex items-center gap-3" data-id="element-1164">
                  <div className="w-10 h-10 rounded-full bg-slate-100 text-navy-600 flex items-center justify-center text-sm font-semibold border border-slate-200" data-id="element-1165">
                    JP
                  </div>
                  <div data-id="element-1166">
                    <p className="text-sm font-medium text-navy-950" data-id="element-1167">
                      J. Pérez
                    </p>
                    <p className="text-xs text-navy-600" data-id="element-1168">
                      jperez@pharmacorp.com
                    </p>
                  </div>
                </div>
                <div className="flex items-center gap-4" data-id="element-1169">
                  <div className="hidden md:flex items-center gap-1.5" data-id="element-1170">
                    <span className="px-2 py-0.5 rounded-md bg-slate-100 text-navy-600 text-[10px] font-medium border border-slate-200" data-id="element-1171">
                      Asuntos Regulatorios
                    </span>
                    <span className="px-2 py-0.5 rounded-md bg-slate-100 text-navy-600 text-[10px] font-medium border border-slate-200" data-id="element-1172">
                      Comercio Exterior
                    </span>
                  </div>
                  <select className="text-xs font-medium text-navy-950 bg-transparent border-none outline-none cursor-pointer" data-id="element-1173">
                    <option data-id="element-1174">Viewer</option>
                    <option data-id="element-1175">Editor</option>
                    <option data-id="element-1176">Admin</option>
                  </select>
                  <button className="text-slate-400 hover:text-navy-950 p-1" data-id="element-1177">
                    <MoreVertical size={16} data-id="element-1178" />
                  </button>
                </div>
              </div>

              {/* Pending Invite */}
              <div className="p-4 flex flex-col sm:flex-row sm:items-center justify-between gap-4 hover:bg-slate-50 transition-colors" data-id="element-1179">
                <div className="flex items-center gap-3" data-id="element-1180">
                  <div className="w-10 h-10 rounded-full bg-slate-50 text-slate-400 flex items-center justify-center border border-slate-200 border-dashed" data-id="element-1181">
                    <Mail size={16} data-id="element-1182" />
                  </div>
                  <div data-id="element-1183">
                    <p className="text-sm font-medium text-navy-950 italic" data-id="element-1184">
                      Invitación pendiente
                    </p>
                    <p className="text-xs text-navy-600" data-id="element-1185">
                      lfernandez@pharmacorp.com
                    </p>
                  </div>
                </div>
                <div className="flex items-center gap-4" data-id="element-1186">
                  <div className="hidden md:flex items-center gap-1.5" data-id="element-1187">
                    <span className="px-2 py-0.5 rounded-md bg-slate-100 text-navy-600 text-[10px] font-medium border border-slate-200" data-id="element-1188">
                      Dirección Técnica
                    </span>
                  </div>
                  <button className="text-xs font-medium text-brand-500 hover:text-brand-600" data-id="element-1189">
                    Reenviar
                  </button>
                  <button className="text-slate-400 hover:text-navy-950 p-1" data-id="element-1190">
                    <MoreVertical size={16} data-id="element-1191" />
                  </button>
                </div>
              </div>
            </div>
          </div> : <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-1192">
            {/* Group 1 */}
            <div className="bg-white rounded-xl border border-slate-200 p-5 shadow-sm hover:shadow-md transition-shadow" data-id="element-1193">
              <div className="flex items-start justify-between mb-4" data-id="element-1194">
                <div data-id="element-1195">
                  <h3 className="text-base font-medium text-navy-950" data-id="element-1196">
                    Asuntos Regulatorios
                  </h3>
                  <p className="text-xs text-navy-600 mt-0.5" data-id="element-1197">3 miembros</p>
                </div>
                <button className="text-slate-400 hover:text-navy-950" data-id="element-1198">
                  <MoreVertical size={16} data-id="element-1199" />
                </button>
              </div>

              <div className="flex items-center mb-5" data-id="element-1200">
                <div className="flex -space-x-2" data-id="element-1201">
                  <div className="w-8 h-8 rounded-full bg-brand-100 text-brand-700 flex items-center justify-center text-xs font-semibold border-2 border-white z-30" data-id="element-1202">
                    DR
                  </div>
                  <div className="w-8 h-8 rounded-full bg-emerald-100 text-emerald-700 flex items-center justify-center text-xs font-semibold border-2 border-white z-20" data-id="element-1203">
                    MG
                  </div>
                  <div className="w-8 h-8 rounded-full bg-amber-100 text-amber-700 flex items-center justify-center text-xs font-semibold border-2 border-white z-10" data-id="element-1204">
                    JP
                  </div>
                </div>
              </div>

              <div className="space-y-2" data-id="element-1205">
                <p className="text-[10px] font-semibold text-slate-400 uppercase tracking-wider" data-id="element-1206">
                  Suscripciones a Alertas
                </p>
                <div className="flex flex-wrap gap-1.5" data-id="element-1207">
                  <span className="px-2 py-1 rounded-md bg-brand-50 text-brand-700 text-[10px] font-medium border border-brand-100" data-id="element-1208">
                    Cambios en trazabilidad
                  </span>
                  <span className="px-2 py-1 rounded-md bg-brand-50 text-brand-700 text-[10px] font-medium border border-brand-100" data-id="element-1209">
                    Importación principios activos
                  </span>
                </div>
              </div>
            </div>

            {/* Group 2 */}
            <div className="bg-white rounded-xl border border-slate-200 p-5 shadow-sm hover:shadow-md transition-shadow" data-id="element-1210">
              <div className="flex items-start justify-between mb-4" data-id="element-1211">
                <div data-id="element-1212">
                  <h3 className="text-base font-medium text-navy-950" data-id="element-1213">
                    Dirección Técnica
                  </h3>
                  <p className="text-xs text-navy-600 mt-0.5" data-id="element-1214">2 miembros</p>
                </div>
                <button className="text-slate-400 hover:text-navy-950" data-id="element-1215">
                  <MoreVertical size={16} data-id="element-1216" />
                </button>
              </div>

              <div className="flex items-center mb-5" data-id="element-1217">
                <div className="flex -space-x-2" data-id="element-1218">
                  <div className="w-8 h-8 rounded-full bg-brand-100 text-brand-700 flex items-center justify-center text-xs font-semibold border-2 border-white z-30" data-id="element-1219">
                    DR
                  </div>
                  <div className="w-8 h-8 rounded-full bg-slate-100 text-navy-600 flex items-center justify-center text-xs font-semibold border-2 border-white z-20" data-id="element-1220">
                    LF
                  </div>
                </div>
              </div>

              <div className="space-y-2" data-id="element-1221">
                <p className="text-[10px] font-semibold text-slate-400 uppercase tracking-wider" data-id="element-1222">
                  Suscripciones a Alertas
                </p>
                <div className="flex flex-wrap gap-1.5" data-id="element-1223">
                  <span className="px-2 py-1 rounded-md bg-brand-50 text-brand-700 text-[10px] font-medium border border-brand-100" data-id="element-1224">
                    "Vademécum PAMI"
                  </span>
                </div>
              </div>
            </div>

            {/* Group 3 */}
            <div className="bg-white rounded-xl border border-slate-200 p-5 shadow-sm hover:shadow-md transition-shadow" data-id="element-1225">
              <div className="flex items-start justify-between mb-4" data-id="element-1226">
                <div data-id="element-1227">
                  <h3 className="text-base font-medium text-navy-950" data-id="element-1228">
                    Comercio Exterior
                  </h3>
                  <p className="text-xs text-navy-600 mt-0.5" data-id="element-1229">4 miembros</p>
                </div>
                <button className="text-slate-400 hover:text-navy-950" data-id="element-1230">
                  <MoreVertical size={16} data-id="element-1231" />
                </button>
              </div>

              <div className="flex items-center mb-5" data-id="element-1232">
                <div className="flex -space-x-2" data-id="element-1233">
                  <div className="w-8 h-8 rounded-full bg-emerald-100 text-emerald-700 flex items-center justify-center text-xs font-semibold border-2 border-white z-40" data-id="element-1234">
                    MG
                  </div>
                  <div className="w-8 h-8 rounded-full bg-amber-100 text-amber-700 flex items-center justify-center text-xs font-semibold border-2 border-white z-30" data-id="element-1235">
                    JP
                  </div>
                  <div className="w-8 h-8 rounded-full bg-slate-100 text-navy-600 flex items-center justify-center text-xs font-semibold border-2 border-white z-20" data-id="element-1236">
                    LF
                  </div>
                  <div className="w-8 h-8 rounded-full bg-slate-100 text-navy-600 flex items-center justify-center text-xs font-semibold border-2 border-white z-10" data-id="element-1237">
                    AL
                  </div>
                </div>
              </div>

              <div className="space-y-2" data-id="element-1238">
                <p className="text-[10px] font-semibold text-slate-400 uppercase tracking-wider" data-id="element-1239">
                  Suscripciones a Alertas
                </p>
                <div className="flex flex-wrap gap-1.5" data-id="element-1240">
                  <span className="px-2 py-1 rounded-md bg-brand-50 text-brand-700 text-[10px] font-medium border border-brand-100" data-id="element-1241">
                    "Licitación pública salud"
                  </span>
                  <span className="px-2 py-1 rounded-md bg-brand-50 text-brand-700 text-[10px] font-medium border border-brand-100" data-id="element-1242">
                    Importación principios activos
                  </span>
                </div>
              </div>
            </div>
          </div>}
      </div>

      <AnimatePresence data-id="element-1243">
        {showCreateGroup && <CreateGroupModal onClose={() => setShowCreateGroup(false)} data-id="element-1244" />}
      </AnimatePresence>
    </AppShell>;
}